import { ToastProvider, ToastViewport } from "@/components/ui/toast";
import type { ReactNode } from "react";

export function ToastZone({ children }: { children: ReactNode }) {
  return (
    <ToastProvider swipeDirection="right">
      {children}
      <ToastViewport />
    </ToastProvider>
  );
}
